import { Component, computed, input, ViewEncapsulation } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';

export type PnIconSize = 'xxs' | 'xs' | 's' | 'm' | 'l' | 'xl';

const SIZE_MAP: Record<PnIconSize, number> = {
    xxs: 8,
    xs: 12,
    s: 16,
    m: 20,
    l: 24,
    xl: 32,
};

@Component({
    selector: 'pn-icon',
    imports: [LucideAngularModule],
    templateUrl: './icon.html',
    styleUrl: './icon.scss',
    encapsulation: ViewEncapsulation.None,
    host: {
        '[style]': 'hostStyle()',
    },
})
export class PnIcon {
    /** Lucide icon name (e.g. 'mail', 'shield-check') */
    name = input.required<string>();

    /** Predefined size from design tokens, or a custom pixel number */
    size = input<PnIconSize | number>('m');

    public resolvedSize = computed(() => {
        const s = this.size();
        return typeof s === 'number' ? s : SIZE_MAP[s];
    });

    protected hostStyle = computed(() => `--pn-icon-size: ${this.resolvedSize()}px`);
}
